
/*
 * ! @chakra-ui/vue v0.10.2 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { p as parsePackIcons, m as merge } from './index-88b4bf19.js';
import { t as toCSSVar } from './index-980f0b61.js';
import { i as internalIcons } from './internal-icons-06a30acb.js';
import { c as colorModeObserver, m as mode } from './color-mode-observer-5bf3a66d.js';
export { m } from './color-mode-observer-5bf3a66d.js';
import { createClientDirective } from './directives.js';
import useToast from './CToast.js';

function e(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++){ n[t]=e[t]; }return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){ return Array.from(e) }}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var t=!1;if("undefined"!=typeof window){var n={get passive(){t=!0;}};window.addEventListener("testPassive",null,n),window.removeEventListener("testPassive",null,n);}var o,i,r="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),l=[],d=!1,c=-1,a=function(e){return l.some((function(t){return !(!t.options.allowTouchMove||!t.options.allowTouchMove(e))}))},u=function(e){var t=e||window.event;return !!a(t.target)||(t.touches.length>1||(t.preventDefault&&t.preventDefault(),!1))},s={enableBodyScroll:function(e){if(r){if(!e){ return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."); }e.ontouchstart=null,e.ontouchmove=null,l=l.filter((function(t){return t.targetElement!==e})),d&&0===l.length&&(document.removeEventListener("touchmove",u,t?{passive:!1}:void 0),d=!1);}else { (l=l.filter((function(t){return t.targetElement!==e}))).length||setTimeout((function(){void 0!==i&&(document.body.style.paddingRight=i,i=void 0),void 0!==o&&(document.body.style.overflow=o,o=void 0);})); }},disableBodyScroll:function(n,s){if(r){if(!n){ return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices."); }if(n&&!l.some((function(e){return e.targetElement===n}))){var v={targetElement:n,options:s||{}};l=[].concat(e(l),[v]),n.ontouchstart=function(e){1===e.targetTouches.length&&(c=e.targetTouches[0].clientY);},n.ontouchmove=function(e){1===e.targetTouches.length&&function(e,t){var n=e.targetTouches[0].clientY-c;!a(e.target)&&(t&&0===t.scrollTop&&n>0?u(e):function(e){return !!e&&e.scrollHeight-e.scrollTop<=e.clientHeight}(t)&&n<0?u(e):e.stopPropagation());}(e,n);},d||(document.addEventListener("touchmove",u,t?{passive:!1}:void 0),d=!0);}}else {!function(e){setTimeout((function(){if(void 0===i){var t=!!e&&!0===e.reserveScrollBarGap,n=window.innerWidth-document.documentElement.clientWidth;t&&n>0&&(i=document.body.style.paddingRight,document.body.style.paddingRight="".concat(n,"px"));}void 0===o&&(o=document.body.style.overflow,document.body.style.overflow="hidden");}));}(s);var f={targetElement:n,options:s||{}};l=[].concat(e(l),[f]);}},install:function(e,t){if(t){var n=t.enableBodyScroll,o=t.disableBodyScroll;n&&(this.enableBodyScroll=n),o&&(this.disableBodyScroll=o);}e.directive("scroll-lock",{inserted:this.inserted.bind(this),componentUpdated:this.componentUpdated.bind(this),unbind:this.unbind.bind(this)});},inserted:function(e,t){t.value&&this.disableBodyScroll(e);},componentUpdated:function(e,t){t.value?this.disableBodyScroll(e):this.enableBodyScroll(e);},unbind:function(e){this.enableBodyScroll(e);}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(s);

var colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000',
  white: '#fff',
  primary: '#1a72ff',
  secondary: '#7425f3',
  tertiary: '#fe9e4d',
  success: '#3ea76a',
  warning: '#ffc61a',
  error: '#dd3b4b',
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)'
  },
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)'
  },
  gray: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#2D3748',
    800: '#1A202C',
    900: '#171923'
  },
  cyan: {
    50: '#EDFDFD',
    100: '#C4F1F9',
    200: '#9DECF9',
    300: '#76E4F7',
    400: '#0BC5EA',
    500: '#00B5D8',
    600: '#00A3C4',
    700: '#0987A0',
    800: '#086F83',
    900: '#065666'
  },
  vue: {
    50: '#e1fbf0',
    100: '#c0ecda',
    200: '#9edfc2',
    300: '#79d0aa',
    400: '#55c392',
    500: '#3caa79',
    600: '#2d845e',
    700: '#1d5e42',
    800: '#0c3a26',
    900: '#001508'
  },
  green: {
    50: '#e2fbed',
    100: '#c2ebd4',
    200: '#9fddb9',
    300: '#7ccf9e',
    400: '#58c184',
    500: '#3ea76a',
    600: '#2e8251',
    700: '#1f5d3a',
    800: '#0f3921',
    900: '#001506'
  },
  orange: {
    50: '#ffefdc',
    100: '#ffd4ae',
    200: '#ffba7f',
    300: '#fe9e4d',
    400: '#fd821b',
    500: '#e46902',
    600: '#b25100',
    700: '#7f3900',
    800: '#4e2200',
    900: '#1f0900'
  },
  red: {
    50: '#ffe5e9',
    100: '#f9bcc2',
    200: '#ee919a',
    300: '#e66673',
    400: '#dd3b4b',
    500: '#c42231',
    600: '#991826',
    700: '#6e101a',
    800: '#44070e',
    900: '#1e0001'
  },
  yellow: {
    50: '#fff9da',
    100: '#ffecad',
    200: '#ffdf7d',
    300: '#ffd24b',
    400: '#ffc61a',
    500: '#e6ac00',
    600: '#b38600',
    700: '#806000',
    800: '#4e3900',
    900: '#1d1300'
  },
  indigo: {
    50: '#f2e5ff',
    100: '#d2b5ff',
    200: '#b285fa',
    300: '#9356f7',
    400: '#7425f3',
    500: '#5a0cda',
    600: '#4608aa',
    700: '#32057b',
    800: '#1e024c',
    900: '#0c001e'
  },
  pink: {
    50: '#fff5f7',
    100: '#fed7e2',
    200: '#fbb6ce',
    300: '#f687b3',
    400: '#ed64a6',
    500: '#d53f8c',
    600: '#b83280',
    700: '#97266d',
    800: '#702459',
    900: '#521B41'
  },
  blue: {
    50: '#def0ff',
    100: '#afd0ff',
    200: '#7db1ff',
    300: '#4b91ff',
    400: '#1a72ff',
    500: '#0058e6',
    600: '#0045b4',
    700: '#003182',
    800: '#001d51',
    900: '#000a21'
  }
};

/**
 * @description This typography style was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var typography = {
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  },
  lineHeights: {
    normal: 'normal',
    none: '1',
    shorter: '1.25',
    short: '1.375',
    base: '1.5',
    tall: '1.625',
    taller: '2'
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem'
  }
};

/**
 * @description These border styles were adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var borders = {
  none: 0,
  '1px': '1px solid',
  '2px': '2px solid',
  '4px': '4px solid'
};
var borderWidths = {
  sm: '1px',
  md: '2px',
  lg: '4px'
};

/**
 * @description These opacity styles was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var opacity = {
  0: '0',
  '20%': '0.2',
  '40%': '0.4',
  '60%': '0.6',
  '80%': '0.8',
  '100%': '1'
};

/**
 * @description These radii styles was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var radii = {
  none: '0',
  sm: '0.125rem',
  md: '0.25rem',
  lg: '0.5rem',
  full: '9999px'
};

/**
 * @description These shadow styles was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var shadows = {
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  inner: 'inset 0 2px 4px 0 rgba( 0, 0, 0, 0.06)',
  none: 'none'
};

/**
 * @description These sizes styles was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var baseSizes = {
  px: '1px',
  0: '0',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  32: '8rem',
  40: '10rem',
  48: '12rem',
  56: '14rem',
  64: '16rem'
};
var largeSizes = {
  full: '100%',
  '3xs': '14rem',
  '2xs': '16rem',
  xs: '20rem',
  sm: '24rem',
  md: '28rem',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem',
  '3xl': '48rem',
  '4xl': '56rem',
  '5xl': '64rem',
  '6xl': '72rem'
};
var containers = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px'
};
var sizes = Object.assign({}, baseSizes, largeSizes, {
  containers: containers
});

/**
 * @description This typography style was adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
};

/**
 * @description These breakpoint styles were adapted from [@chakra-ui](https://chakra-ui.com/)
 */
var _breakpoints = ['30em', '48em', '62em', '80em'];
_breakpoints.sm = _breakpoints[0];
_breakpoints.md = _breakpoints[1];
_breakpoints.lg = _breakpoints[2];
_breakpoints.xl = _breakpoints[3];
var createBreakpoints = function createBreakpoints(config) {
  if (config === void 0) config = {};
  return Object.assign({}, {
    base: '0em'
  }, config);
};
var breakpoints = createBreakpoints(_breakpoints);

var space = baseSizes;
var theme = Object.assign({}, {
  breakpoints: breakpoints,
  zIndices: zIndices,
  radii: radii,
  opacity: opacity,
  borders: borders,
  colors: colors
}, typography, {
  borderWidths: borderWidths,
  sizes: sizes,
  shadows: shadows,
  space: space
});

/**
 * Chakra-ui Component library plugin
 * @type {import("../../types").ChakraPlugin}
 */

var Chakra = {
  /**
   *
   * @param {Vue} Vue
   * @param {import("../../types").Options} options
   */
  install: function install(Vue, options) {
    if (options === void 0) options = {};
    var packIcons = {};
    var extendedIcons = options.icons ? options.icons.extend || {} : {};

    if (options.icons) {
      packIcons = parsePackIcons(options.icons.iconSet);
    }

    var icons = Object.assign({}, internalIcons, packIcons, extendedIcons); // Recursively merge extended theme variables

    var mergedTheme = toCSSVar(merge(theme, options.extendTheme));
    Vue.directive('chakra', createClientDirective(mergedTheme)); // Bind theme and icons to prototype

    Vue.prototype.$chakra = {
      theme: mergedTheme,
      icons: icons
    };
    var toast = useToast();
    Vue.prototype.$toast = toast;
    /** Install dependent plugins */

    Vue.use(s);
    Vue.mixin({
      computed: {
        chakraColorMode: function chakraColorMode() {
          return colorModeObserver.colorMode;
        },
        chakraTheme: function chakraTheme() {
          return colorModeObserver.theme;
        },
        chakraToggleColorMode: function chakraToggleColorMode() {
          return colorModeObserver.toggleColorMode;
        },
        $mode: function $mode(vm) {
          return function (lightValue, darkValue) {
            return mode(lightValue, darkValue, colorModeObserver);
          };
        }
      }
    });
  }
};

export { Chakra as C, theme as d };
